var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhaseA(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 18,
    viewBox: "0 0 15 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.31184 1.80853C8.30451 1.97694 8.27264 2.14338 8.21725 2.3026L3.416 16.1026C3.21604 16.6773 2.67421 17.0625 2.0657 17.0625C1.06675 17.0625 0.375762 16.0641 0.727642 15.1292L5.93428 1.2955C6.22764 0.516069 6.97627 0 7.80908 0C8.12608 0 8.37911 0.264293 8.36532 0.580992L8.31184 1.80853ZM13.4662 17.0625C12.8552 17.0625 12.3115 16.6751 12.1119 16.0976L7.40807 2.48223C7.36015 2.34352 7.32871 2.19965 7.31441 2.05359L7.1811 0.692488C7.14477 0.321473 7.43629 0 7.80908 0C8.58217 0 9.27453 0.478572 9.54772 1.20178L14.8066 15.1234C15.1606 16.0606 14.4681 17.0625 13.4662 17.0625ZM11.0332 10.7344C11.6772 10.7344 12.1992 11.2564 12.1992 11.9004C12.1992 12.5444 11.6772 13.0664 11.0332 13.0664H4.08398C3.44001 13.0664 2.91797 12.5444 2.91797 11.9004C2.91797 11.2564 3.44001 10.7344 4.08398 10.7344H11.0332Z",
    fill: "#87C8E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhaseA);
export default __webpack_public_path__ + "static/media/phaseA.6d33dd838bcd946db51c1e3e434af39d.svg";
export { ForwardRef as ReactComponent };